import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		width: "320px",
	},
	radioGroup: {
		margin: "10px 7px",
	},
	radioElementBig: {
		width: "120px",
	},
	radioElementSmall: {
		width: "80px",
	},
});
